import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GoodsSameJourney.less';

export default class GoodsSameJourney extends OfficialPage {
  state = {
    centerLat: '',
    centerLng: '',
    addressListMakers: [],
    circles: [
      {
        latitude: '',
        longitude: '',
        fillColor: '#ff710033',
        radius: 2000
      }
    ],
    sameJourneyId: '',
    notInRange: false,
    showAddress: false,
    storeStyle: {}
  }
  callout = {
    content: '门店地址',
    fontSize: 14,
    color: '#333333',
    borderRadius: 4,
    bgColor: '#ffffff',
    padding: 10,
    display: 'ALWAYS',
    textAlign: 'center',
    notInRange: false
  }
  franchiseeId = ''
  
  constructor(props) {
    super(props);
    document.title = '选择配送点';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.franchiseeId = options.franchiseeId || ''
    this.setData({
      from: options.from || '',
      sameJourneyId: options.sameJourneyId || '',
      compindex: options.compindex || ''
    })
    this.dataInitial()
  }

  componentDidMount() {
    if (this.isBack) {
      this.getAddressList()
    }
  }

  dataInitial = () => {
    this.getAppECStoreConfig()
    this.getAddressList()
    this.getCurrentLocation()
    this.getPickUpGoodsType()
    this.isShowAddress()
  }
  getPickUpGoodsType = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 2,
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        if (!res.data.app_store_data) {
          return
        }
        let centerLng = res.data.app_store_data.longitude
        let centerLat = res.data.app_store_data.latitude
        let addressListMakers = _this.data.addressListMakers
        addressListMakers.push({
          latitude: centerLat,
          longitude: centerLng,
          iconPath: '/images/delivery.png',
          width: 20,
          height: 20
        })
        _this.setData({
          centerLng: centerLng,
          centerLat: centerLat,
          'circles[0].longitude': centerLng,
          'circles[0].latitude': centerLat,
          'circles[0].radius': +res.data.config_data.deliver_distance,
          addressListMakers: addressListMakers,
          showMap: true
        })
      }
    })
  }
  getAddressList = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addressList',
      data: {
        sub_shop_app_id: _this.franchiseeId
      },
      success: function (res) {
        let addressList = res.data
        let addressListMakers = _this.data.addressListMakers
        let notInRange = false
        addressList.map(item => {
          let iconPath
          if (item.address_info.label == 0) {
            iconPath =
              'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-home.png'
          } else if (item.address_info.label == 1) {
            iconPath =
              'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-school.png'
          } else if (item.address_info.label == 2) {
            iconPath =
              'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-company.png'
          } else {
            iconPath =
              'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-other.png'
          }
          addressListMakers.push({
            latitude: item.latitude,
            longitude: item.longitude,
            iconPath: iconPath,
            width: 24,
            height: 28
          })
          if (item.config && item.config.intra_city != 1) {
            notInRange = true
          }
        })
        let sameJourneyId = _this.data.sameJourneyId
          ? _this.data.sameJourneyId
          : addressList.length && addressList[0].id
        _this.setData({
          notInRange: notInRange,
          addressList: addressList,
          sameJourneyId: sameJourneyId,
          addressListMakers: addressListMakers
        })
      }
    })
  }
  selectDelivery = event => {
    let index = event.currentTarget.dataset.index
    let addressList = this.data.addressList
    this.setData({
      sameJourneyId: addressList[index].id
    })
    this.sureDelivery()
  }
  sureDelivery = () => {
    let sameJourneyId = this.data.sameJourneyId
    let pages = app.getCurrentPages()
    let prePage = pages[pages.length - 2]
    if (!prePage) {
      Toast.info('当前操作需要返回上一页');
      app.turnBack();
      return;
    }
    let addressList = this.data.addressList
    if (!sameJourneyId) {
      app.showModal({
        content: '请选择配送点'
      })
      return
    }
    // 对前一个页面的竖版列表列表组件进行设置 vertical-list
    if (this.data.compindex && this.data.compindex > -1) {
      let compindex = this.data.compindex
      for (let i = 0; i < addressList.length; i++) {
        if (addressList[i].id == sameJourneyId) {
          prePage.setData({
            ['eles[' + compindex + '].selectSameJourneyId']: sameJourneyId,
            ['eles[' + compindex + '].selectSameJourney']: addressList[i],
            ['eles[' + compindex + '].sameJourneyTimeType']: '',
            ['eles[' + compindex + '].sameJourneyDateTime']: ''
          })
        }
      }
    } else {
      for (let i = 0; i < addressList.length; i++) {
        if (addressList[i].id == sameJourneyId) {
          prePage.setData({
            selectSameJourneyId: sameJourneyId,
            selectSameJourney: addressList[i],
            sameJourneyTimeType: '',
            sameJourneyDateTime: ''
          })
        }
      }
    }
    app.turnBack()
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }
  getCurrentLocation = () => {
    let _this = this
    app.getLocation({
      success(res) {
        const latitude = res.latitude
        const longitude = res.longitude
        app.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          method: 'post',
          data: {
            latitude: latitude,
            longitude: longitude
          },
          success: function (res) {
            let addressListMakers = _this.data.addressListMakers
            addressListMakers.push({
              latitude: latitude,
              longitude: longitude,
              iconPath:
                'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-me.png',
              width: 20,
              height: 20
            })
            _this.setData({
              currentLocationData: res.data,
              addressListMakers: addressListMakers
            })
          }
        })
      }
    })
  }
  opratAddress = () => {
    this.isBack = true
    app.turnToPage('/eCommerce/pages/myAddress/myAddress?from=form')
  }
  isShowAddress = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getSwitchBySwitchName',
      method: 'post',
      data: {
        switch_name: 'intra_city_address_position'
      },
      success: function (res) {
        if (!res.status) {
          that.setData({
            showAddress: res.data == 1 ? true : false
          })
        }
      }
    })
  }

  render() {
    const {
      currentLocationData,
      storeStyle,
      showAddress,
      centerLng,
      centerLat,
      circles,
      addressListMakers,
      showMap,
      addressList,
      sameJourneyId,
      from,
      notInRange
    } = this.state

    return (
      <div className="official-page goods-same-journey">
        <TopNav title="选择配送点" />
        {showAddress && (
          <div
            className="current-location-box"
            onClick={this.selectGoodsSameJourney}
          >
            <span className="ico-moon icon-goods-location"></span>
            <span>
              {(currentLocationData && currentLocationData.formatted_addresses && currentLocationData.formatted_addresses.recommend) || '暂无地址'}
            </span>
            <span
              onClick={this.getCurrentLocation}
              className="pull-right renew-position"
              style={convertLineStyleData('color:' + storeStyle.theme)}
            >
              重新定位
            </span>
          </div>
        )}
        {showMap && showAddress && (
          <div>
            {/* TODO
            <Map
              longitude={centerLng}
              latitude={centerLat}
              scale="14"
              circles={circles}
              markers={addressListMakers}
            ></Map> */}
          </div>
        )}
        <div className="receipt-header">收货地址</div>
        <div className="delivery-list-box">
          {addressList && addressList.map((item, index) => {
            return (
              <React.Fragment key={item.id}>
                {(from != 'preview' || (item.config && item.config.intra_city == 1)) && (
                  <div
                    className="delivery-list"
                    onClick={this.selectDelivery}
                    data-index={index}
                  >
                    <span className="ico-moon icon-goods-location"></span>
                    <div className="delivery-list-content">
                      <div className="delivery-list-title">
                        {item.config && item.config.intra_city == 1 && (
                          <label className="support-same-city address-label">
                            可同城
                          </label>
                        )}
                        {item.address_info.label == 0 && (
                          <label className="home address-label">家</label>
                        )}
                        {item.address_info.label == 2 && (
                          <label className="company address-label">公司</label>
                        )}
                        {item.address_info.label == 1 && (
                          <label className="school address-label">学校</label>
                        )}
                        {item.address_info.name +
                          ' ' +
                          item.address_info.contact}
                      </div>
                      <div className="delivery-list-detail">
                        {item.address_info.province.text +
                          item.address_info.city.text +
                          item.address_info.district.text +
                          (item.detail_address || '')}
                      </div>
                    </div>
                    <label
                      style={convertLineStyleData(
                        sameJourneyId == item.id
                          ? 'color:' + storeStyle.theme
                          : ''
                      )}
                      className={
                        'delivery-check-box ico-moon icon-success-tip ' +
                        (sameJourneyId == item.id ? 'checked' : '')
                      }
                    ></label>
                  </div>
                )}
              </React.Fragment>
            )
          })}
        </div> 
        {from == 'preview' && addressList && !!addressList.length && notInRange && (
          <React.Fragment>
            <div className="receipt-header no-support-header">
              以下地址超出配送范围
            </div>
            <div className="delivery-list-box no-support-pick">
              {addressList.map((item, index) => {
                return (
                  <React.Fragment key={item.id}>
                    {item.config && item.config.intra_city != 1 && (
                      <div className="delivery-list">
                        <span className="ico-moon icon-goods-location"></span>
                        <div className="delivery-list-content">
                          <div className="delivery-list-title">
                            {item.address_info.label == 0 && (
                              <label className="address-label">家</label>
                            )}
                            {item.address_info.label == 2 && (
                              <label className="address-label">公司</label>
                            )}
                            {item.address_info.label == 1 && (
                              <label className="address-label">学校</label>
                            )}
                            {item.address_info.name +
                              ' ' +
                              item.address_info.contact}
                          </div>
                          <div className="delivery-list-detail">
                            {item.address_info.province.text +
                              item.address_info.city.text +
                              item.address_info.district.text +
                              (item.detail_address || '')}
                          </div>
                        </div>
                        <label className="delivery-check-box ico-moon icon-success-tip"></label>
                      </div>
                    )}
                  </React.Fragment>
                )
              })}
            </div>
          </React.Fragment>
        )}
        {!(addressList && addressList.length) && (
          <div className="same-journey-null">
            <img src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-journey-null.png" />
            <div onClick={this.opratAddress}>
              暂无收货地址,
              <span
                style={convertLineStyleData(
                  storeStyle.theme
                    ? 'color:' + storeStyle.theme
                    : 'color:' + '#ff7100'
                )}
              >
                去添加地址
              </span>
            </div>
          </div>
        )}
        <div
          className="sure-delivery"
          style={convertLineStyleData('background:' + storeStyle.theme)}
          onClick={this.opratAddress}
        >
          管理收货地址
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/goods-same-journey/GoodsSameJourney.jsx